module.exports = __webpack_public_path__ + "static/media/masturah-profile.17c25e57.png";